/**
 * Utility for fetching user's country based on IP.
 * Implements session storage caching to minimize API calls.
 */
export const getUserCountry = async () => {
  const CACHE_KEY = "user_geo_data";
  
  // 1. Try to get from session storage first
  const cached = sessionStorage.getItem(CACHE_KEY);
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      console.error("Failed to parse cached geo data", e);
    }
  }

  // 2. Fetch from API
  try {
    const res = await fetch("https://ipapi.co/json/");
    if (!res.ok) throw new Error("Geo API failed");
    
    const data = await res.json();
    
    // Save to session storage for subsequent calls in the same session
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
    
    return data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Geo IP lookup skipped:", error.message);
    }
    return null;
  }
};
